import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const LightModeIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_854_7927)">
        <path d="M8.583 1.71c.361 0 .654.293.654.655v1.309a.655.655 0 1 1-1.309 0v-1.31c0-.36.293-.654.655-.654M8.732 5.1a3.631 3.631 0 1 0 0 7.263 3.631 3.631 0 0 0 0-7.263M4.663 3.737a.655.655 0 1 0-.925.926l.935.935a.655.655 0 1 0 .925-.926zM1.71 8.583c0-.362.293-.655.655-.655h1.309a.655.655 0 1 1 0 1.31h-1.31a.655.655 0 0 1-.654-.655M5.598 12.54a.655.655 0 0 0-.925-.926l-.935.935a.655.655 0 0 0 .925.926zM8.583 12.903c.361 0 .654.293.654.654v1.31a.655.655 0 1 1-1.309 0v-1.31c0-.361.293-.654.655-.654M12.54 11.614a.655.655 0 0 0-.926.926l.935.935a.654.654 0 1 0 .926-.926zM12.903 8.583c0-.362.293-.655.654-.655h1.31a.654.654 0 1 1 0 1.31h-1.31a.655.655 0 0 1-.654-.655M13.475 4.663a.654.654 0 1 0-.926-.926l-.935.935a.654.654 0 1 0 .925.926z"></path>
      </g>
      <defs>
        <clipPath id="clip0_854_7927">
          <path fill="#fff" d="M1.71 1.71h14.4v14.4H1.71z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default LightModeIcon;
